
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const CTASection = () => {
  return (
    <section className="py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden bg-primary">
          {/* Background gradient effect */}
          <div className="absolute inset-0 opacity-20">
            <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-accent blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-96 h-96 rounded-full bg-accent blur-3xl"></div>
          </div>
          
          <div className="relative z-10 py-16 px-8 text-center max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
              Ready to Automate Faster?
            </h2>
            <p className="text-lg text-white/80 mb-8">
              Join our community of automation experts and discover workflows that will transform your business.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link to="/marketplace">
                <Button size="lg" variant="secondary" className="px-8">
                  Browse Marketplace
                </Button>
              </Link>
              <Link to="/auth?action=signup">
                <Button size="lg" className="bg-white text-primary hover:bg-white/90 px-8">
                  Create Account
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
